import React from 'react';
import Footer from '../header_footer/Footer';
import Navigation from '../header_footer/Navgation';
import Hero from './Hero';
import NewArrivalsSection from './NewArrivalsSection';
import CategoriesCarousel from './CategoriesCarousel';
import InstagramSection from './InstagramSection';
import WelcomePopup from '../main_compos/WelcomePopup';

export default function Home() {
  return (
    <div className='min-h-screen bg-[#f7f5f2] text-black'>
      <Navigation />
      <Hero />
      <NewArrivalsSection />
      <CategoriesCarousel />
      <InstagramSection />
      <Footer />
      <WelcomePopup />
    </div>
  )
}
